import { render, staticRenderFns } from "./ModalText.vue?vue&type=template&id=215f21ef&scoped=true&"
import script from "./ModalText.vue?vue&type=script&lang=js&"
export * from "./ModalText.vue?vue&type=script&lang=js&"
import style0 from "./ModalText.vue?vue&type=style&index=0&id=215f21ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215f21ef",
  null
  
)

export default component.exports